// extracted by mini-css-extract-plugin
export default {"videoModal":"VideoModal_videoModal__n7Fi-","overlay":"VideoModal_overlay__eh1ip","content":"VideoModal_content__+PQ-7","close":"VideoModal_close__pLCy-"};